import React from 'react';
import { InvitationStatus } from '@/types';
import { IconBadge } from '@ygtechnologies/bygr-frontend-component-library';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faClockNine, faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { t } from '@lingui/core/macro';

interface BuyerStatusBadgeProps {
    status: InvitationStatus;
}

const BuyerStatusBadge: React.FC<BuyerStatusBadgeProps> = ({ status }) => {
    let color = 'var(--rui-color-success-200)'; //'#81CCAA';
    let textColor = 'var(--rui-color-text)'; // '#039855';
    let text = t`Active`;
    let icon = faCheck;

    switch (status) {
        case InvitationStatus.Pending:
            color = 'var(--rui-color-grey-300)'; //'#757270';
            text = t`Not invited`;
            icon = faClockNine;
            break;
        case InvitationStatus.Failed:
            color = 'var(--rui-color-error)';
            text = t`Failed`;
            icon = faTimes;
            break;
        case InvitationStatus.Canceled:
            color = 'var(--rui-color-error)';
            text = t`Canceled`;
            icon = faTimes;
            break;
        case InvitationStatus.Registered:
            // color = 'var(--rui-color-success)';
            text = t`Active`;
            icon = faCheck;
            break;
        case InvitationStatus.Sent:
            color = 'var(--rui-color-warning-300)'; // '#FED891';
            // textColor = 'var(--rui-color-warning)'; // '#CA8D1B';
            text = t`Invited`;
            icon = faEnvelope;
            break;
    }

    return <IconBadge icon={icon} color={color} text={text} textColor={textColor} />;
};

export default BuyerStatusBadge;
